// extracted by mini-css-extract-plugin
module.exports = {"gvjoyup":"gvjoyup","c132w1ct":"c132w1ct"};